import { z } from 'zod'
import { AuditPropsSchema } from '../common'
import { CompanyIdSchema, idSchemaV2, isId, TeamIdSchema, UserIdSchema } from '../ids'
import { ArchivableSchema } from '../archive'

export const ExternalLinkIdSchema = idSchemaV2('ExternalLink')
export type ExternalLinkId = z.infer<typeof ExternalLinkIdSchema>
export const isExternalLinkId = isId(ExternalLinkIdSchema)

export const ExternalLinkScopeIdSchema = z.union([CompanyIdSchema, TeamIdSchema])
export type ExternalLinkScopeId = z.infer<typeof ExternalLinkScopeIdSchema>
export const isExternalLinkScopeId = (value: string): value is ExternalLinkScopeId => {
  return ExternalLinkScopeIdSchema.safeParse(value).success
}

export const UnsavedExternalLinkSchema = z.object({
  url: z.string(),
  label: z.string(),
  description: z.string().optional(),
  icon: z.string().optional(),
  color: z.string().optional(),
  scopeId: ExternalLinkScopeIdSchema,
  order: z.number(),
})

export type UnsavedExternalLink = z.infer<typeof UnsavedExternalLinkSchema>

export const ExternalLinkSchema = z.object({
  ...AuditPropsSchema.shape,
  ...UnsavedExternalLinkSchema.shape,
  ...ArchivableSchema.shape,
  externalLinkId: ExternalLinkIdSchema,
  userId: UserIdSchema,
  companyId: CompanyIdSchema,
})

export type ExternalLinkData = z.infer<typeof ExternalLinkSchema>
